import { ExternalLink, TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  CryptoIcon,
  CurrencyValue,
  EtherScanPictogram,
  Flex,
  DataTable,
  RelativeDateTime
} from '@blockanalitica/ui';
import { useMemo } from 'react';

export default function EventsTable({
  data,
  sorting,
  pagination,
  collateralSymbol,
  collateralAddress
}) {
  const columns: TableColumn[] = useMemo(
    () => [
      {
        header: 'Event',
        getCell: (row) => row.operation,
        sortingField: 'operation',
        columnSize: ['minmax(100px, auto)']
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Debt
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.ddebt}
            options={{ trend: true, iconSize: '0' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'debt'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Collateral
            <CryptoIcon
              name={collateralSymbol}
              address={collateralAddress}
              size="0"
            />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue
            value={row.dink}
            options={{ trend: true, iconSize: '0' }}
          />
        ),
        getCellBottom: (row) => (
          <CurrencyValue
            color="muted"
            fontSize="-1"
            value={Number(row.dink) * Number(row.collateral_price)}
            options={{
              currency: 'USD',
              nullable: ''
            }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'ink'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex
            gap={['xs', '3xs']}
            color="muted"
            alignItems="center"
            justifyContent="center">
            <RelativeDateTime value={row.datetime} />
            <ExternalLink
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              icon={<EtherScanPictogram size="0" />}
            />
          </Flex>
        ),
        sortingField: 'order_index',
        cellAlign: 'flex-end',
        headerAlign: 'flex-end'
      }
    ],
    [collateralSymbol, collateralAddress]
  );

  if (data) {
    return (
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <TableSkeleton />;
}
